import { AlertType, TextWarning } from 'components/Alert/Alert'
import { Card, CardBody } from 'components/Card/Card'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { PROCUREMENT_PRIORITY_META } from 'constants/meta'
import { colors, ColorVariant, DividerVertical, Flex } from 'styling/GlobalStyles'
import { BigText, NormalText, SmallText } from 'styling/TypographyV2'
import { PurchaseRequestItemType } from 'types/procurement'
import {
  ProcurementPurchaseRequestItemResponse,
  SelectedQuote,
} from 'types/procurement/purchaseRequest.model'

export const DetailItem = ({
  item,
  winningOffer,
}: {
  item: ProcurementPurchaseRequestItemResponse
  winningOffer?: SelectedQuote
}) => {
  return (
    <Card borderLeft={colors.orange} padding='0.5rem 1rem'>
      <CardBody>
        <Flex between center>
          <Flex column gap='0.25rem'>
            <Flex gap='0.5rem' center>
              <BigText semibold>{item.inventoryItem?.name || item.name}</BigText>
              {item.type === PurchaseRequestItemType.Item ? (
                <StatusPill status='success'>SKU</StatusPill>
              ) : (
                <StatusPill status='accent'>FREE TEXT</StatusPill>
              )}
              {!item.inventoryItem && (
                <TextWarning
                  title='Unresolved'
                  type={AlertType.WARNING}
                  colorVariant={ColorVariant.PRIMARY}
                />
              )}
              {item.urgency && (
                <StatusPill dot status={item.urgency === 4 ? 'danger' : item.urgency === 3 ? 'warning' : 'neutral'}>
                  {PROCUREMENT_PRIORITY_META[item.urgency].label}
                </StatusPill>
              )}
            </Flex>
            {item.inventoryItem?.sku && (
              <NormalText colorVariant={ColorVariant.SECONDARY}>
                {item.inventoryItem?.sku}
              </NormalText>
            )}
          </Flex>
          <Flex>
            <Flex column justcenter gap='0.25rem'>
              <NormalText colorVariant={ColorVariant.SECONDARY}>PICS</NormalText>
              <NormalText bold>{item.quantity}</NormalText>
            </Flex>
            {winningOffer && (
              <>
                <DividerVertical />
                <Flex column justcenter gap='0.25rem'>
                  <NormalText colorVariant={ColorVariant.SECONDARY}>PRICE</NormalText>
                  <NormalText bold>
                    {
                      winningOffer?.items.find(
                        (i) => i.procurementPurchaseRequestItem.id === item.id,
                      )?.price
                    }{' '}
                    {winningOffer.currency}
                  </NormalText>
                  <SmallText colorVariant={ColorVariant.SECONDARY}>each</SmallText>
                </Flex>
              </>
            )}
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  )
}
